import SdkLoaderBase from './template';

export default SdkLoaderBase;